export default __webpack_public_path__ + "static/media/anthem-website-logos_pledge1.baf43447.webp";